module.exports = __webpack_public_path__ + "img/Sanat_Madan.855412a2.svg";